type Dot = "teal" | "amber" | "danger";

type Ticket = { dot: Dot; label: string };

const TICKETS: Ticket[] = [
  { dot: "teal", label: "NVE · Norwegian grid" },
  { dot: "teal", label: "Matrikkelen · parcels" },
  { dot: "amber", label: "Statnett · queue 2033–35" },
  { dot: "danger", label: "NGU · quick-clay risk" },
  { dot: "teal", label: "Laji.fi · biodiversity" },
  { dot: "teal", label: "MET Norway · free-cool" },
  { dot: "teal", label: "Fingrid · Finnish grid" },
  { dot: "amber", label: "Riksantikvaren · heritage" },
  { dot: "teal", label: "ENTSO-E · EU prices" },
  { dot: "amber", label: "TeleGeography · subsea" },
  { dot: "teal", label: "MML · Suomi land" },
  { dot: "danger", label: "GTK · acid-sulfate soil" },
  { dot: "teal", label: "SYKE · Natura 2000" },
  { dot: "amber", label: "PeeringDB · IXPs" },
  { dot: "teal", label: "DIBK NAP · zoning" },
  { dot: "teal", label: "FMI · Finnish weather" },
  { dot: "teal", label: "Miljødirektoratet · NiN" },
  { dot: "amber", label: "EEA · E-PRTR facilities" },
  { dot: "amber", label: "Museovirasto · heritage" },
  { dot: "teal", label: "NIBIO AR5 · land-cover" },
  { dot: "amber", label: "Kartverket · port depths" },
  { dot: "amber", label: "NVDB · Norwegian roads" },
  { dot: "amber", label: "EU-DEM · elevation" },
  { dot: "teal", label: "OpenStreetMap · Overpass" },
  { dot: "amber", label: "Väylä · Finnish roads" },
  { dot: "amber", label: "OpenCelliD · towers" },
  { dot: "amber", label: "Traficom · broadband" },
  { dot: "amber", label: "SSB · settlements" },
];

const DOT_HEX: Record<Dot, string> = {
  teal: "#4dd4e8",
  amber: "#f0b23a",
  danger: "#e24b4a",
};

export default function Marquee() {
  return (
    <section
      aria-hidden
      className="relative border-y-[0.5px] border-white/[0.06] overflow-hidden py-5"
      style={{ background: "rgba(15, 20, 32, 0.4)" }}
    >
      <div className="marquee-track flex gap-3 whitespace-nowrap">
        {[...TICKETS, ...TICKETS, ...TICKETS].map((t, i) => (
          <div
            key={i}
            className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-bg-card border-hairline-base shrink-0"
          >
            <span
              className="inline-block w-1.5 h-1.5 rounded-full"
              style={{ background: DOT_HEX[t.dot] }}
            />
            <span className="font-mono text-[11.5px] uppercase tracking-[0.12em] text-ink/80">
              {t.label}
            </span>
          </div>
        ))}
      </div>
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-24"
        style={{
          background:
            "linear-gradient(to right, var(--bg-base), transparent)",
        }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-24"
        style={{
          background:
            "linear-gradient(to left, var(--bg-base), transparent)",
        }}
      />
    </section>
  );
}
